import { ReactNode, useContext } from 'react'

import { StringsContext } from '@lib/strings-context'
import { CartContext } from '@lib/cart'

import Button, { ButtonProps } from '@components/buttons/button'

interface ProductAddProps {
  onClick: () => void
  disabled?: boolean
  className?: string
  children: ReactNode
}

const ProductAdd = ({
  onClick,
  variant,
  color,
  size = 'normal',
  icon,
  disabled = false,
  className,
  children,
}: ProductAddProps & ButtonProps) => {
  const strings = useContext(StringsContext)
  const { cart, isCartProductAdding } = useContext(CartContext)

  return (
    <Button
      id="product-add-to-cart-button"
      variant={variant}
      color={color}
      size={size}
      icon={icon}
      disabled={disabled || !cart || isCartProductAdding}
      onClick={onClick}
      className={className}
    >
      {!cart && <>{strings.buttonUnavailable}</>}
      {cart && isCartProductAdding && <>{strings.buttonAdding}</>}
      {cart && !isCartProductAdding && <>{children}</>}
    </Button>
  )
}

export default ProductAdd
